export const SHOW_MODAL_CERTIFICACAO = 'SHOW_MODAL_CERTIFICACAO';
export const showModal = (showModal) => ({
  type: SHOW_MODAL_CERTIFICACAO,
  payload: {
    showModal,
  },
});
export const SELECIONAR_CERTIFICADOS = 'SELECIONAR_CERTIFICADOS';
export const certificadosSelecionados = (certificadosSelecionados) => ({
  type: SELECIONAR_CERTIFICADOS,
  payload: {
    certificadosSelecionados,
  },
});
export const TOTAL_CERTIFICADOS_EXIBIDOS = 'TOTAL_CERTIFICADOS_EXIBIDOS';
export const listaExibido = (listaExibido) => ({
  type: TOTAL_CERTIFICADOS_EXIBIDOS,
  payload: {
    listaExibido,
  },
});
export const TOTAL_CERTIFICADOS_PENDENTES = 'TOTAL_CERTIFICADOS_PENDENTES';
export const totalPendentes = (totalPendentes) => ({
  type: TOTAL_CERTIFICADOS_PENDENTES,
  payload: {
    totalPendentes,
  },
});
export const LISTA_CERTIFICADOS_PENDENTES = 'LISTA_CERTIFICADOS_PENDENTES';
export const listaPendentes = (listaPendentes) => ({
  type: LISTA_CERTIFICADOS_PENDENTES,
  payload: {
    listaPendentes,
  },
});
export const ATUALIZAR_PAGINA_CERTIFICADOS = 'ATUALIZAR_PAGINA_CERTIFICADOS';
export const pagina = (pagina) => ({
  type: ATUALIZAR_PAGINA_CERTIFICADOS,
  payload: {
    pagina,
  },
});




// WEBPACK FOOTER //
// ./src/app/common/certificacao/certificacao.action.js